import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';

export const InvoiceReceiptPdf = createLoadableComponent(
  () => import('./containers/InvoiceReceiptPdfPageGraphqlContainer'),
);

export const ReceiptPdf = createLoadableComponent(
  () => import('./containers/ReceiptPdfGraphqlContainer'),
);
